// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Yp4M","notes":"Notes_notes__39e4f"};